import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'stepper-input',
  templateUrl: './stepper-input.component.html',
  styleUrls: ['./stepper-input.component.scss'],
})
export class StepperInputComponent implements OnInit {
  title = "Stepper input";
  @Input() initialValue;
  @Input() step: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 0;
  @Input() symbol: string;
  renderedValue: string;
  value: number = 0;
  @Output() stepValueChanged = new EventEmitter();

  ngOnInit() {
    this.value = this.initialValue;
    this.renderedValue = this.value.toString() + this.symbol;
  }

  toggleMore = () => {
    if (this.step + this.value <= this.max) {
      this.value = this.value + this.step;
      this.renderedValue = this.value.toString() + this.symbol;
      this.stepValueChanged.emit(this.value);
    }
  }

  toggleLess = () => {
    if (this.value - this.step >= this.min) {
      this.value = this.value - this.step;
      this.renderedValue = this.value.toString() + this.symbol;
      this.stepValueChanged.emit(this.value);
    }
  }

}
